<template>
  <div class="w-full px-5">
    <el-row :gutter="20">
      <el-col :xs="24" :sm="8">
        <el-form-item prop="name">
          <label class="text-sm block">Supply Code:</label>
          <el-input class="w-full" v-model="form.code" type="text"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="8">
        <el-form-item prop="supplier_id">
          <label class="text-sm block">Supplier:</label>
          <el-select class="w-full" v-model="form.supplier_id" filterable placeholder="Please select...">
            <el-option
              v-for="supplier in suppliers"
              :key="supplier.id"
              :label="supplier.name"
              :value="supplier.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="8">
        <el-form-item prop="outlet_id">
          <label class="text-sm block">Outlet:</label>
          <el-select class="w-full" v-model="form.outlet_id" filterable placeholder="Please select...">
            <el-option
              v-for="outlet in outlets"
              :key="outlet.id"
              :label="outlet.name"
              :value="outlet.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="px-2 pb-5" v-if="form && form.id">
      <el-button type="info" plain size="small" icon="el-icon-plus"
                 @click="$modal.show('new-supplied-good-modal')">Add Goods</el-button>
    </el-row>
    <template v-if="form.goods && form.goods.length > 0">
      <el-table :data="form.goods" style="width: 100%">
        <el-table-column
          label="Goods">
          <template slot-scope="scope">{{scope.row.name}}</template>
        </el-table-column>
        <el-table-column
          label="Related Item">
          <template slot-scope="scope">{{scope.row.item.name}}</template>
        </el-table-column>
        <el-table-column
          label="Quantity">
          <template slot-scope="scope">{{scope.row.quantity}}</template>
        </el-table-column>
        <el-table-column
          label="Actions">
          <template slot-scope="scope">
            <el-button @click="openEditDialog(scope.row)" type="text" size="small">
              <i class="text-xl el-icon-edit-outline mr-4"></i>
            </el-button>
            <el-button @click="deleteSuppliedGood(scope.row.id)" type="text" size="small">
              <i class="text-xl text-red-500 el-icon-delete-solid"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table><br>
    </template>
    <NewSuppliedGoodForm />
    <UpdateSuppliedGoodForm />
  </div>
</template>

<script>

import NewSuppliedGoodForm from './NewSuppliedGoodForm.vue';
import UpdateSuppliedGoodForm from './UpdateSuppliedGoodForm.vue';

export default {
  name: 'SupplyForm',
  props: ['form'],
  components: {
    NewSuppliedGoodForm,
    UpdateSuppliedGoodForm,
  },
  computed: {
    suppliers() {
      return this.$store.state.InventoryModule.Suppliers.suppliers;
    },
    outlets() {
      return this.$store.state.OutletModule.outlets;
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch('InventoryModule/Suppliers/fetchAllSuppliers');
      await this.$store.dispatch('OutletModule/fetchAllOutlets');
    } catch (e) {
      this.$notify.error({
        title: 'Error',
        message: 'Something went wrong please try again.',
      });
    }
  },
  methods: {
    openEditDialog(suppliedGood) {
      this.$store.commit('InventoryModule/Supplies/setSuppliedGood', { property: 'supplied_good', payload: suppliedGood });
      this.$modal.show('update-supplied-good-modal');
    },
    deleteSuppliedGood(suppliedGoodId) {
      this.$confirm('Are you sure you want to delete this supplied good?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('InventoryModule/Supplies/deleteSuppliedGood', { suppliedGoodId });
          this.$notify.success({
            title: 'Success',
            message: 'Supply good has been deleted.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
